import classes from "./darkButton.module.scss";

interface Props {
  label: string;
  type?: string;
  submit?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}

const DarkButton = ({
  label,
  type,
  onClick,
  submit = false,
  disabled,
}: Props) => {
  return (
    <button
      className={`${classes.button} ${
        type == "inverted" ? classes.inverted : ""
      }`}
      type={submit ? "submit" : "button"}
      onClick={onClick}
      disabled={!!disabled}
    >
      {label}
    </button>
  );
};

export default DarkButton;
